import { Link } from "react-router-dom";
import { Phone, MessageCircle, Mail, MapPin, Facebook, Instagram, Linkedin, Youtube, Twitter, ArrowRight } from "lucide-react";
import { company, products } from "../mock/mock";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="bg-[#0d2240] text-white pt-14 pb-4 mt-6">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-4">
            <Logo variant="light" />
            <p className="text-white/70 text-sm mt-4 leading-relaxed">
              Leading manufacturers, suppliers, wholesalers, traders & retailers of high-quality
              adhesive tapes serving industries across India since 2008.
            </p>
            <div className="flex items-center gap-2 mt-5">
              {[
                { Icon: Facebook, href: company.social.facebook, label: "Facebook" },
                { Icon: Instagram, href: company.social.instagram, label: "Instagram" },
                { Icon: Linkedin, href: company.social.linkedin, label: "LinkedIn" },
                { Icon: Youtube, href: company.social.youtube, label: "YouTube" },
                { Icon: Twitter, href: company.social.twitter, label: "Twitter" },
              ].map(({ Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={label}
                  className="w-9 h-9 grid place-items-center rounded-full bg-white/10 hover:bg-[#c8102e] transition-colors"
                >
                  <Icon size={15} />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-heading font-semibold text-[15px] mb-4">Quick Links</h4>
            <ul className="flex flex-col gap-2 text-[13.5px] text-white/75">
              {[
                { to: "/", label: "Home" },
                { to: "/about-us", label: "About Us" },
                { to: "/products", label: "Products" },
                { to: "/contact-us", label: "Contact Us" },
                { to: "/contact-us", label: "Request a Quote" },
              ].map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="hover:text-[#f4b223] inline-flex items-center gap-1">
                    <ArrowRight size={11} />
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading font-semibold text-[15px] mb-4">Top Products</h4>
            <ul className="flex flex-col gap-2 text-[13.5px] text-white/75">
              {products.slice(0, 6).map((p) => (
                <li key={p.id}>
                  <Link to={`/products/${p.slug}`} className="hover:text-[#f4b223] inline-flex items-center gap-1">
                    <ArrowRight size={11} />
                    {p.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-heading font-semibold text-[15px] mb-4">Reach Us</h4>
            <ul className="flex flex-col gap-3 text-[13.5px] text-white/80">
              <li className="flex items-start gap-2">
                <span className="w-7 h-7 rounded-full bg-[#c8102e] grid place-items-center mt-0.5 shrink-0"><MapPin size={13} /></span>
                <span>{company.address}</span>
              </li>
              <li>
                <a href={`tel:+91${company.phone}`} className="flex items-center gap-2 hover:text-[#f4b223]">
                  <span className="w-7 h-7 rounded-full bg-[#c8102e] grid place-items-center shrink-0"><Phone size={13} /></span>
                  +91 {company.phone}
                </a>
              </li>
              <li>
                <a href={`https://wa.me/91${company.whatsapp}`} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[#f4b223]">
                  <span className="w-7 h-7 rounded-full bg-[#25D366] grid place-items-center shrink-0"><MessageCircle size={13} /></span>
                  +91 {company.whatsapp}
                </a>
              </li>
              <li>
                <a href={`mailto:${company.email}`} className="flex items-center gap-2 hover:text-[#f4b223] break-all">
                  <span className="w-7 h-7 rounded-full bg-[#c8102e] grid place-items-center shrink-0"><Mail size={13} /></span>
                  {company.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-5 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-[12px] text-white/60">
          <p>© {new Date().getFullYear()} {company.name}. All rights reserved.</p>
          <p>
            Domain: <a href={`https://${company.domain}`} className="text-[#f4b223] hover:underline">{company.domain}</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
